import React, {useState, useEffect} from 'react';
import Form from '../form/form';
import Gaper_logo from '../../asstes/login/gaper_logo.png';


function Left_panel({ isLogin }) {

  return (
    <div className='grid grid-col-4 bg-black-3 h-screen'>
          {/* empty div to manage spacing */}
            <div className=''></div>
            {/* form section */}
            <div className='grid grid-col-3 md:pl-10 row-span-2'>
              {/* Gaper Logo */}
                <div className='md-1:grid md-1:justify-items-center'>
                  <img src={Gaper_logo} alt="logo" className=''/>
                </div>
                {/* Logn Form */}
                <div className=''>
                  <Form isLogin={isLogin} />
                </div>
                {/* empty div to manage spacing */}
                <div></div>
            </div>
            <div className=' grid grid-col-3'>
              {/* empty div to manage spacing */}
              <div></div>
              {/* Links */}
              <div className='row-span-2 text-white-1 text-center px-10 text-sm 1xl:text-lg'>No account? Join in Gaper as a <span className='text-blue-4'>freelancer</span> or <span className='text-blue-4'>company</span> Copyrights 2021 Gaper</div>
            </div>
        </div>
  )
}

export default Left_panel